import type { GridColDef } from '@repo/go-table';

export const isColumnsOrderModelEqual = (left: string[] | undefined, right: string[]): boolean => {
  return (left?.length ?? 0) === right.length && right.every((field, index) => left?.[index] === field);
};

export const isValidColumnsOrderModel = (orderModel: string[], columns: GridColDef[]): boolean => {
  if (orderModel.length !== columns.length) {
    return false;
  }

  return columns.every((column) => orderModel.includes(column.field));
};

/** Keep saved relative order; append missing fields; drop unknown. */
export const mergeColumnsOrderModel = (saved: string[], columnFields: string[]): string[] => {
  const fieldSet = new Set(columnFields);
  const kept = saved.filter((field) => fieldSet.has(field));
  const missing = columnFields.filter((field) => !kept.includes(field));

  return [...kept, ...missing];
};
